var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"push-container"},[_c('div',{staticClass:"push-content"},[_c('div',{staticClass:"leftBar"},[_c('sys-sidebar')],1),_c('div',{staticClass:"rightBar"},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }